const theme = {
	label: {
		fontFamily: '"Noto Sans", Arial, sans-serif',
		color: '#444',
		fontSize: '13px'
	},
	bulkdownloadDetails: {
		width: '99%',
		display: 'inline-flex',
		paddingTop: '1%',
		paddingLeft: '0',
		paddingBottom: '3%'
	},
	Div: {
		marginRight: '2%',
		width: '25%',
		color: '#595959',
		fontSize: '13px'
	},
	row: {
		marginBottom: '20px',
		width: '97%'
	},
	DivCreatePage: {
		marginRight: '5%',
		width: '25%',
		color: '#595959',
		fontSize: '13px'
	},
	rowCreatePage: {
		marginBottom: '20px',
		width: '100%'
	},
	gridTitle: {
		fontSize: '40px',
	},
	downloadButton: {
		marginTop: '35px',
		marginRight:'10px'
	},
	gridTitleName: {
		fontWeight: '500'
	},
	countDiv: {
		fontWeight: '500',
		marginBottom: '20px',
		marginTop: '20px'
	},
	selectDiv: {
		fontWeight: '500',
		marginBottom: '15px',
	},
	button: {
		marginRight: '1em',
		marginLeft: '4px',
		height: '33px',
		maxHeight: '33px',
		fontSize: '16px',
		marginBottom: '10px'
	},
	submitButton: {
		marginRight: '1em',
		marginBottom: '10px',
		height: '33px',
		maxHeight: '33px',
		fontSize: '16px'
	},
    buttonRow: {
		marginBottom: '10px',
		width: '97%',
		marginTop: '100px'
	},
	searchButton: {
		marginBottom: '10px',
		height: '33px',
		maxHeight: '33px',
		fontSize: '16px'
	},
	ibDate:{
		width: "7em",
		borderRadius: "4px"
	}
};
export default theme;
